import axios from 'axios';

const signOut = () => (
  (dispatch) => {
    return axios.post('/logout', {})
      .then((response) => {
        window.location = '/login';
      })
      .catch((error) => {
      if (error.response && error.response.status === 401) {
        window.location = '/login';
      }
    });
  }
);

export default signOut;
